import { ErrorMessage } from "@hookform/error-message";
import * as moment from "moment";
import React, { useEffect, useMemo, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import {
  Col,
  Modal,
  ModalBody,
  Row,
} from "reactstrap";
import {
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Button,
  Icon,
  RSelect
} from "../../components/Component";
import { useUser } from "../../context/user";
import { GET, POST } from "../../helper/api";
import { getToken } from "../../helper/auth";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import { REPORT_ASSIGN_CONFIRM_TYPE, REPORT_ASSIGN_CONFIRM_TYPE_OPTIONS, SETTING_KEY } from "../../utils/Utils";
import BillApprovedComponent from "./billapprovedcomponent/BillApprovedComponent";
import RangeDatePicker from "../../components/range-date-picker/RangeDatePicker";

const DEFAULT_WAITING_REVIEW = {
  reviewerIds: []
}

const BillApprovedManager = () => {

  const {
    state: { user },
  } = useUser();
  const [data, setData] = useState({
    ins: [],
    outs: [],
  });

  const {
    errors,
    handleSubmit,
    getValues,
    control,
  } = useForm({
    defaultValues: {
      ...DEFAULT_WAITING_REVIEW
    },
  });

  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const [loading, setLoading] = useState(false);
  const [smOption, setSmOption] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [listDayNotYetRequestReview, setListDayNotYetRequestReview] = useState([]);
  const [reviewerNotConfirms, setReviewerNotConfirms] = useState([]);

  const [needApproveByUser, setNeedApproveByUser] = useState([]);
  const [userOptions, setUserOptions] = useState([]);
  const [warehouseOptions, setWarehouseOptions] = useState([]);

  const [summary, setSummary] = useState({
    ins: {},
    outs: {},
  });

  const [view, setView] = useState({
    addReport: false,
    agreeReport: false,
    cancelReport: false,
  });

  const [filter, setFilter] = useState({
    warehouseId: searchParams.get("warehouseId") || undefined,
    confirmType: searchParams.get("confirmType") || REPORT_ASSIGN_CONFIRM_TYPE.NOT_APPROVED_BY_ME,
  });
  const [rangeDate, setRangeDate] = useState({
    startDate: moment(searchParams.get("startDate") || undefined).startOf('days').toDate(),
    endDate: moment(searchParams.get("endDate") || undefined).endOf('days').toDate(),
  });


  const onRangeChange = (dates) => {
    const [startDate, endDate] = dates;
    setRangeDate({
      startDate: startDate ? moment(startDate)?.startOf('days').toDate() : startDate,
      endDate: endDate ? moment(endDate)?.endOf('days').toDate() : endDate
    });
    if (startDate && endDate) {
      setTimeNow(moment().valueOf());
    }
  }

  useEffect(() => {
    const newParams = new URLSearchParams({
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
      ...(filter.confirmType ? { confirmType: filter.confirmType } : {}),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })
    getData();
  }, [filter, timeNow]);

  const toggle = (type) => {
    setView({
      ...view,
      [type]: !view[type],
    });
  };

  const resetData = () => {
    onFormCancel();
    setTimeNow(moment().valueOf());
  };


  useEffect(() => {
    GET(`/user/list-can-confirm-assign-review/${SETTING_KEY.ASSIGN_REVIEWER_BILL}`, {}, true).then((resp) => {
      setUserOptions(
        resp.data?.map((c) => ({
          label: c.name,
          value: c.id,
          data: c,
        }))
      );
    });

    GET("/warehouse", {}, true).then((resp) => {
      setWarehouseOptions(
        resp.data?.rows?.map(
          (c) =>
          ({
            label: c.name,
            value: c.id,
            data: c,
          })
        )
      );
    });
  }, []);

  // function to close the form modal
  const onFormCancel = () => {
    setView({ addReport: false, agreeReport: false, cancelReport: false });
  };

  const getData = () => {
    setLoading(true);
    setData({
      ins: [],
      outs: [],
    });

    let params = {
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
      ...(filter.confirmType ? { confirmType: filter.confirmType } : {}),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
    };
    GET(`/bill/report-bill-by-day`, params, true)
      .then(({ data: { data, summary, listDayNotYetRequestReview, needApproveByUser, reviewerNotConfirms } }) => {
        setData(data)
        setSummary(summary)
        setListDayNotYetRequestReview(listDayNotYetRequestReview.map(e => moment(e, 'YYYY-MM-DD').format('DD')))
        setNeedApproveByUser(needApproveByUser.map(e => moment(e, 'YYYY-MM-DD').format('DD-MM-YYYY')))
        setReviewerNotConfirms(reviewerNotConfirms);
      })
      .finally(() => {
        setLoading(false);
      });

  };

  const exportExcel = () => {
    const params = new URLSearchParams({
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
      ...(filter.confirmType ? { confirmType: filter.confirmType } : {}),
      ...(filter.warehouseId ? { warehouseId: filter.warehouseId } : {}),
      token: getToken(),
    })
    const url = `${process.env.REACT_APP_API_URL}/api/v1/bill/report-bill-by-day-excel?${params.toString()}`;
    window.open(url, '_blank')
  };

  const addReportAssign = () => {
    const { reviewerIds } = getValues()
    let payload = {
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
      reviewerIds
    };
    POST(`bill/add-report-assign`, payload, {}, true)
      .then((res) => {
        toast.success("Thêm báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const actionReportAssign = (confirmType) => {
    POST(`/bill/action-report-assign`, {
      confirmType,
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
    }, {}, true)
      .then((res) => {
        toast.success("Duyệt báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };

  const cancelReportAssignReport = () => {
    let payload = {
      startDate: moment(rangeDate.startDate).format('YYYY-MM-DD'),
      endDate: moment(rangeDate.endDate).format('YYYY-MM-DD'),
    };
    POST(`bill/cancel-report-assign`, payload, {}, true)
      .then((res) => {
        toast.success("Huỷ yêu cầu duyệt báo cáo thành công");
        resetData();
      })
      .catch(({ response }) => {
        toast.error(
          response?.data?.error || "Có lỗi xảy ra! Vui lòng thử lại."
        );
      });
  };


  const maxRangeDate = useMemo(() => {
    if (!rangeDate.startDate) return null;
    const endOfMonth = moment(rangeDate.startDate).endOf('month').toDate();
    if (moment().isBefore(endOfMonth)) {
      return moment().toDate();
    }
    return endOfMonth;
  }, [rangeDate.startDate]);

  return (
    <React.Fragment>
      <Head title="Quản lý đơn hàng"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Đơn hàng</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <RangeDatePicker
                          selected={rangeDate.startDate}
                          startDate={rangeDate.startDate}
                          onChange={onRangeChange}
                          endDate={rangeDate.endDate}
                          maxDate={maxRangeDate}
                          selectsRange
                          className="form-control date-picker"
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-control-wrap">
                        <RSelect
                          isClearable
                          placeholder={"Lọc tình trạng duyệt"}
                          options={REPORT_ASSIGN_CONFIRM_TYPE_OPTIONS}
                          value={REPORT_ASSIGN_CONFIRM_TYPE_OPTIONS.find((c) => c.value === filter.confirmType) || null}
                          onChange={(val) => {
                            setFilter({
                              ...filter,
                              confirmType: val?.value || undefined,
                            });
                          }}
                        />
                      </div>
                    </li>
                    <li>
                      <div className="form-group">
                        <div className="form-control-wrap">
                          <RSelect
                            isClearable
                            placeholder={"Lọc theo kho"}
                            options={warehouseOptions}
                            value={warehouseOptions.find((c) => c.value === filter.warehouseId) || null}
                            onChange={(val) => {
                              setFilter({
                                ...filter,
                                warehouseId: val?.value || undefined,
                              });
                            }}
                          />
                        </div>
                      </div>
                    </li>


                    {userOptions.map(e => e.value).includes(user.id) ? <li>
                      <div>
                        <Button
                          color="secondary"
                          onClick={() => {
                            toggle('agreeReport')
                          }}
                        >
                          <span>Kiểm duyệt báo cáo</span>
                        </Button>
                      </div>
                    </li>
                      : <>
                        <li>
                          <div>
                            <Button
                              color="secondary"
                              onClick={() => {
                                toggle('addReport')
                              }}
                            >
                              <span>Gửi báo cáo</span>
                            </Button>
                          </div>
                        </li>
                        <li className="">
                          <div className="">
                            <Button
                              className=""
                              color="warning"
                              onClick={() => {
                                toggle('cancelReport')
                              }}
                            >
                              <span>Huỷ yêu cầu duyệt báo cáo</span>
                            </Button>
                          </div>
                        </li>
                      </>
                    }

                    <li className="">
                      <div className="">
                        <Button
                          className=""
                          color="secondary"
                          onClick={exportExcel}
                        >
                          <span>Xuất excel</span>
                        </Button>
                      </div>
                    </li>

                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <BillApprovedComponent
          reviewerNotConfirms={reviewerNotConfirms}
          listDayNotYetRequestReview={listDayNotYetRequestReview}
          needApproveByUser={needApproveByUser}
          loading={loading}
          data={data}
          summary={summary}
          startDate={rangeDate.startDate}
          endDate={rangeDate.endDate}
        />
      </Content>

      <Modal isOpen={view.addReport} toggle={() => onFormCancel()}>
        <ModalBody className="modal-body-lg text-center">
          <div className="nk-modal">
            <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
            <h4 className="nk-modal-title">
              Bạn có chắc muốn gửi duyệt báo cáo từ ngày {moment(rangeDate.startDate).format('DD/MM/YYYY')} đến {moment(rangeDate.endDate).format('DD/MM/YYYY')} không?
            </h4>
            <form className="text-left" onSubmit={handleSubmit(addReportAssign)}>
              <Row>
                <Col md="12">
                  <div className="form-group">
                    <label className="form-label" htmlFor="customer">
                      Người duyệt
                      <span className="text-danger">*</span>
                    </label>
                    <div className="form-control-wrap">
                      <Controller
                        control={control}
                        name="reviewerIds"
                        rules={{ required: "Vui lòng nhập thông tin" }}
                        render={({ onChange, value, name, ref }) => (
                          <RSelect
                            isMulti
                            classNamePrefix="form-control"
                            inputRef={ref}
                            name={name}
                            options={userOptions}
                            value={userOptions.filter(
                              (c) => {
                                return value?.includes(c.value)
                              }
                            )}
                            onChange={(val) => {
                              onChange(val.map(e => e.value) || [])
                            }}
                          />
                        )}
                      />
                      <ErrorMessage
                        errors={errors}
                        name="reviewerIds"
                        render={({ message }) => (
                          <span className="invalid">{message}</span>
                        )}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              <div className="nk-modal-action mt-5 d-flex justify-content-around">
                <Button
                  type={'button'}
                  color="light"
                  size="lg"
                  className="btn-mw mr-5"
                  onClick={() => onFormCancel()}
                >
                  Huỷ bỏ
                </Button>
                <Button
                  color="primary"
                  size="lg"
                  className="btn-mw"
                >
                  Xác nhận
                </Button>
              </div>
            </form>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={view.agreeReport} toggle={() => onFormCancel()}>
        <ModalBody className="modal-body-lg text-center">
          <div className="nk-modal">
            <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
            <h4 className="nk-modal-title">
              Duyệt báo cáo từ ngày {moment(rangeDate.startDate).format('DD/MM/YYYY')} đến {moment(rangeDate.endDate).format('DD/MM/YYYY')} không?
            </h4>
            <div className="nk-modal-action mt-5 d-flex justify-content-around">
              <Button
                type={'button'}
                color="light"
                size="lg"
                className="btn-mw mr-5"
                onClick={() => onFormCancel()}
              >
                Huỷ bỏ
              </Button>
              <Button
                color="primary"
                size="lg"
                className="btn-mw"
                onClick={() => actionReportAssign(REPORT_ASSIGN_CONFIRM_TYPE.APPROVED)}
              >
                Duyệt
              </Button>

              <Button
                color="primary"
                size="lg"
                className="btn-mw"
                onClick={() => actionReportAssign(REPORT_ASSIGN_CONFIRM_TYPE.NOT_APPROVED)}
              >
                Từ chối
              </Button>

            </div>
          </div>
        </ModalBody>
      </Modal>

      <Modal isOpen={view.cancelReport} toggle={() => onFormCancel()}>
        <ModalBody className="modal-body-lg text-center">
          <div className="nk-modal">
            <Icon className="nk-modal-icon icon-circle icon-circle-xxl ni ni-list bg-success"></Icon>
            <h4 className="nk-modal-title">
              Bạn có chắc muốn huỷ yêu cầu duyệt báo cáo từ ngày {moment(rangeDate.startDate).format('DD/MM/YYYY')} đến {moment(rangeDate.endDate).format('DD/MM/YYYY')} không?
            </h4>
            <div className="nk-modal-action mt-5 d-flex justify-content-around">
              <Button
                type={'button'}
                color="light"
                size="lg"
                className="btn-mw mr-5"
                onClick={() => onFormCancel()}
              >
                Huỷ bỏ
              </Button>
              <Button
                color="primary"
                size="lg"
                className="btn-mw"
                onClick={() => cancelReportAssignReport()}
              >
                Xác nhận
              </Button>
            </div>
          </div>
        </ModalBody>
      </Modal>
    </React.Fragment>
  );
};

export default BillApprovedManager;
